import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Archive as ArchiveIcon, Visibility as VisibilityIcon } from '@mui/icons-material';
import { clearFormInput, formInput } from 'actions/FormActions';
import LOOKUP from 'constants/lookup';
// Basic Components
import Button from 'screens/components/basic/Button';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import ListCheckbox from 'screens/components/basic/ListCheckbox';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "EmployeeHours";
class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.employeeOptions,
            selectStatus: false
        }
        this.clearInput = this.clearInput.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.resetState = this.resetState.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        nextProps.employeeOptions.sort((a, b) => {
            const nameA = a.text.toUpperCase().trim();
            const nameB = b.text.toUpperCase().trim();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            // names must be equal
            return 0;
        }
        );
        // this.setState({ data: nextProps.employeeOptions.filter(e => e.branch.includes(parseInt(nextProps.isBranch, 10) || 1)) });
        this.setState({ data: nextProps.employeeOptions });
    }

    clearInput() {
        this.setState({
            selectStatus: "clear"
        }, () => this.props.clearFormInput(`EmployeeHoursEmployeeName`)
        );
    }

    selectAll() {
        //console.log(this.state.data);
        var allIds = [];
        const myData = this.state.data;
        myData.map((item, index) => {
            allIds.push(item.value);
        });
        //console.log(allIds);

        this.setState({
            selectStatus: "all"
        }, () => this.props.formInput(allIds, `EmployeeHoursEmployeeName`)
        );
    }

    resetState() {
        this.setState({
            selectStatus: false
        });
    }

    render() {
        return (
            <CardSimple className="p-1">
                <div className="row row_margin_none">
                    <div className="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                        <DatePickerInput
                            name={componentName + LOOKUP.report.common.beginDate.name}
                            floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                            hintText={LOOKUP.report.common.beginDate.label + "*"}
                            fullWidth={true}
                        />
                    </div> {/* .col START DATE */}
                    <div className="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                        <DatePickerInput
                            name={componentName + LOOKUP.report.common.endDate.name}
                            floatingLabelText={LOOKUP.report.common.endDate.label}
                            hintText={LOOKUP.report.common.endDate.label}
                            fullWidth={true}
                        />
                    </div> {/* .col END DATE */}
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <BranchSelectAutoCompleteInput
                            name={componentName + LOOKUP.report.common.branchName}
                            label={LOOKUP.report.common.branch + "*"}
                        />
                    </div> {/* .col BRANCH */}

                    {/* Show list of employee after the branch is selected */}
                    <div className='row' >
                        {
                            this.props.isBranch ?
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-2">
                                    <div>
                                        <h3>List of Employees</h3>
                                        <Button
                                            type="FlatButtonPrimary"
                                            label="Select All"
                                            secondary={false}
                                            //TODO: Add function to select all employees
                                            onTouchTap={this.selectAll}
                                        />
                                        <Button
                                            type="FlatButtonPrimary"
                                            label="Deselect All"
                                            //TODO: Add function to deselect all employees
                                            onTouchTap={this.clearInput}
                                        />
                                    </div>

                                    <ListCheckbox
                                        name={componentName + LOOKUP.report.common.employeeName.name}
                                        selectStatus={this.state.selectStatus}
                                        callBack={this.resetState}
                                        collection={this.state.data} />


                                </div>
                                :
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-2 p-0">
                                    <p className='purpleText'><b>Note: </b><i>Please select a branch to see the employee list.</i></p>
                                </div>
                        }{/* .col EMPLOYEES */}

                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pb-2">
                            <Button
                                type="IconInButton"
                                className="pull-right mt-2 ml-1 btnNewBrandPOS"
                                name={componentName + LOOKUP.report.common.viewReport.name}
                                label={LOOKUP.report.common.viewReport.label}
                                icon={<VisibilityIcon />}
                                onTouchTap={this.props.showBody}
                            />
                            <Button
                                type="DownloadButton"
                                className="pull-right mt-2 ml-1 btnNewBrandPOS"
                                name={componentName + LOOKUP.report.common.downloadReport.name}
                                label={LOOKUP.report.common.downloadReport.label}
                                onTouchTap={this.props.download}
                            />
                        </div>
                    </div>

                </div>
            </CardSimple>
        )
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions
    }
}

const mapDispatchToProps = dispatch => {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
